module.exports = __webpack_public_path__ + "static/media/students-icon-2.42e25a20.svg";